import Carousel from "./Carousel";
import nextArrowImage from "../../assets/images/slider/next-arrow.svg";
import prevArrowImage from "../../assets/images/slider/prev-arrow.svg";
import { Settings } from "react-slick";
import { useContext } from "react";
import { LangContext } from "../../App";

function SampleNextArrow({ className = "", onClick } : { className? : string, onClick? : () => void}) {
  const { lang } = useContext(LangContext);
  return (
    <img
      role="button"
      onClick={onClick}
      src={nextArrowImage}
      alt="next slide"
      className={className}
      title={lang ? "Go to next slide" : "أنتقل للشريحة التالية"}
      aria-label={lang ? "Go to next slide" : "أنتقل للشريحة التالية"}
    />
  );
}

function SamplePrevArrow({ className = "", onClick } : { className? : string, onClick? : () => void }) {
  const { lang } = useContext(LangContext);

  return (
    <img
      role="button"
      onClick={onClick}
      src={prevArrowImage}
      alt="previous slide"
      className={className}
      title={lang ? "Go to next slide" : "أنتقل للشريحة السابقة"}
      aria-label={lang ? "Go to next slide" : "أنتقل للشريحة السابقة"}
    />
  );
}

const settings : Settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  vertical: true,
  verticalSwiping: true,
  dots: true,
  adaptiveHeight: true,
  customPaging : (index: number) => {
    return <button type="button" title={`Show slide ${index + 1}`}>{index + 1}</button>
  },
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

export default function VerticalCarousel({ items = [] } : { items : JSX.Element[]}) {
  const { lang } = useContext(LangContext);

  return (
    <div className="vertical-carousel">
      <Carousel settings={settings} items={items} />
      
    </div>
  );
}
